import { Award, Sparkles } from "lucide-react";
import { CERTIFICATE } from "@/data/salonData";
import { Reveal } from "@/lib/useReveal";

export default function Certifications() {
  return (
    <section
      id="certifications"
      data-testid="certifications-section"
      className="relative py-20 md:py-28 overflow-hidden"
    >
      <div className="absolute inset-0 -z-10 bg-gradient-to-b from-[#fff5f8] to-white">
        <div className="absolute top-10 right-10 w-[400px] h-[400px] bg-gradient-radial from-[#d4af37]/15 to-transparent rounded-full blur-3xl" />
      </div>

      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          {/* Image side */}
          <Reveal className="lg:col-span-6">
            <div className="relative">
              <div className="absolute -inset-3 bg-gradient-to-br from-[#d4af37]/30 to-[#d98a99]/20 rounded-3xl blur-2xl" />
              <div
                className="relative rounded-3xl overflow-hidden bg-gradient-to-br from-[#fff0f5] to-[#fff5f8] border border-[#d4af37]/30 shadow-[0_30px_60px_-15px_rgba(212,175,55,0.25)]"
                style={{ aspectRatio: "1/1" }}
              >
                <img
                  src={CERTIFICATE.image}
                  alt="Anshi Thakur receiving certificate from Atul Chauhan"
                  loading="lazy"
                  className="w-full h-full object-contain"
                />
              </div>
              {/* Gold corner accents */}
              <div className="absolute -top-3 -left-3 w-12 h-12 border-t-2 border-l-2 border-[#d4af37] rounded-tl-3xl" />
              <div className="absolute -bottom-3 -right-3 w-12 h-12 border-b-2 border-r-2 border-[#d4af37] rounded-br-3xl" />
            </div>
          </Reveal>

          {/* Text side */}
          <div className="lg:col-span-6">
            <Reveal>
              <span className="heading-flourish">Certified Artistry</span>
              <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#2a1b18] font-medium mt-4 leading-[1.05]">
                {CERTIFICATE.title}
              </h2>
              <div className="mt-3 inline-flex items-center gap-2 text-[#b56477]">
                <Award size={18} />
                <span className="text-sm font-medium">
                  {CERTIFICATE.subtitle}
                </span>
              </div>
            </Reveal>

            <Reveal delay={120}>
              <p className="mt-6 text-[#5c4642] text-base md:text-lg leading-relaxed">
                {CERTIFICATE.description}
              </p>
            </Reveal>

            <Reveal delay={220}>
              <div className="mt-8 grid grid-cols-2 gap-4">
                <div className="glass-pink rounded-2xl p-5">
                  <Sparkles size={20} className="text-[#d4af37] mb-2" />
                  <div className="font-display text-2xl text-[#2a1b18] font-semibold">
                    3 Days
                  </div>
                  <div className="text-xs text-[#5c4642] mt-1">
                    Intensive Masterclass
                  </div>
                </div>
                <div className="glass-pink rounded-2xl p-5">
                  <Award size={20} className="text-[#b56477] mb-2" />
                  <div className="font-display text-2xl text-[#2a1b18] font-semibold">
                    Bridal Pro
                  </div>
                  <div className="text-xs text-[#5c4642] mt-1">
                    Certified Skill Set
                  </div>
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
